import {MD_WIDTH} from "@main/helpers/const";

const TIMEOUT_RESIZE_OBSERVER = 100;

class Search {
    btnShowSearchBlock = document.querySelector(".js-show-search-block");

    constructor(el) {
        this.el = el;
        this.form = this.el.querySelector("form");
        this.input = this.el.querySelector(".js-search-input");
        this.searchBtn = this.el.querySelector(".js-search-btn");
        this.btnCloseSearchBlock = this.el.querySelector(".js-close-search-block");
        this.resultList = this.el.querySelector(".js-search-list");
        this.btnReset = this.el.querySelector(".js-search-reset");

        this.resizeObserver = new ResizeObserver(this.onResizeWindow.bind(this), TIMEOUT_RESIZE_OBSERVER);
        this.resizeObserver.observe(document.body);

        this.listenEvents();
    }

    onResizeWindow([entry]) {
        if (entry.contentRect.width < MD_WIDTH) {
            this.input.setAttribute("placeholder", "Введите текст");
        } else {
            this.input.setAttribute("placeholder", "Введите текст для поиска");
        }
    }

    listenEvents() {
        if (this.btnShowSearchBlock) {
            this.btnShowSearchBlock.addEventListener("click", (e) => {
                e.preventDefault();
                this.openSearchBlock();
                this.addFocusSearchInput();
            })
        }
        
        if (this.btnCloseSearchBlock) {
            this.btnCloseSearchBlock.addEventListener("click", () => {
                this.closeSearchBlock();
            })
        }

        if (this.btnReset) {
            this.btnReset.addEventListener("click", (e) => {
                e.preventDefault();
                this.input.value = "";
                this.searchBtn.setAttribute("disabled", "disabled");
                this.btnReset.classList.add("hidden");
                return false;
            })
        }

        this.input.addEventListener("keyup", () => {
            this.updateOnChangeInput()
        });

        this.input.addEventListener("change", () => {
            this.updateOnChangeInput()
        });
    }

    openSearchBlock() {
        this.el.classList.remove("hidden");
    }

    addFocusSearchInput() {
        this.input.focus();
    }

    closeSearchBlock() {
        this.el.classList.add("hidden");
        this.input.value = "";
        this.searchBtn.setAttribute("disabled", "disabled");

        if (this.resultList && !this.resultList.classList.contains("hidden")) {
            this.resultList.classList.add("hidden");
        }
    }

    updateOnChangeInput() {
        if (this.input.value !== "") {
            this.searchBtn.removeAttribute("disabled");

            if (this.resultList) {
                this.resultList.classList.remove("hidden");
            }
            
            if (this.btnReset) {
                this.btnReset.classList.remove("hidden");
            }
        } else {
            this.searchBtn.setAttribute("disabled", "disabled");

            if (this.resultList) {
                this.resultList.classList.add("hidden");
            }

            if (this.btnReset) {
                this.btnReset.classList.add("hidden");
            }
        }
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-search-block")
        .forEach(el => new Search(el));
});
